import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { CouncilsAccessListState } from '../types'
import { councilsAccessFullList } from './helpers'

const noCouncilsAccessListConfig = {
  councilsAccessList: [],
  isAcInitalized: false,
  isAcLoading: true,
  hasAcError: false,
}

interface CouncilsAccessListPayload {
  councilsAccessList?: []
}

const initialState: CouncilsAccessListState = { ...noCouncilsAccessListConfig }

export const councilsAccessListSlice = createSlice({
  name: 'CouncilsAccessList',
  initialState,
  reducers: {
    fetchCouncilsAccessList: (state) => {
      state.isAcLoading = true
      state.hasAcError = false
    },
    setCouncilsAccessList: (state, action: PayloadAction<CouncilsAccessListPayload>) => {
      state.councilsAccessList = action.payload.councilsAccessList
      state.isAcLoading = false
      state.isAcInitalized = true
      state.hasAcError = false
    },
    deleteCouncilsAccessList: (state, action: PayloadAction<CouncilsAccessListPayload>) => {
      state.councilsAccessList = []
      state.isAcInitalized = false
      state.isAcLoading = false
      state.hasAcError = false
    },
    fetchCouncilsAccessListFailed: (state) => {
      state.councilsAccessList = []
      state.isAcInitalized = false
      state.isAcLoading = false
      state.hasAcError = true
    },
  },
})

export const fetchAllCouncilsAccessList = () => async (dispatch) => {
  try {
    dispatch(fetchCouncilsAccessList())
    const councilsAccessList = await councilsAccessFullList()
    dispatch(
      setCouncilsAccessList({
        councilsAccessList,
      }),
    )
  } catch (error) {
    message.error('Access list not fond')
    dispatch(fetchCouncilsAccessListFailed())
  }
}

// Actions
export const { fetchCouncilsAccessList, setCouncilsAccessList, fetchCouncilsAccessListFailed } =
  councilsAccessListSlice.actions

export default councilsAccessListSlice.reducer
